<div fxFlex="100" fxFlex.gt-sm="80" fxFlexOffset.gt-sm="10" style="margin-top: 20px;">
    <button routerLink="/angebotsversionslisten" mat-raised-button color="primary" class="mb-1">
      Alle Angebotslisten
    </button>
    <mat-card>
      <mat-card-header>
        <mat-card-title>
          Angebotsversionsliste "{{avl?.listenName}}"
        </mat-card-title>
      </mat-card-header>
      <mat-card-content fxLayoutAlign="center" *ngIf="loading">
        <mat-spinner diameter="30" ></mat-spinner>
      </mat-card-content>
      <mat-card-content [hidden]="loading">
        <mat-card *ngIf="avl">
            <mat-card-header>
                <mat-card-title>
                    Basisdaten
                </mat-card-title>
                <button style="margin-left: auto;" color="primary" mat-raised-button (click)="editMode = true" *ngIf="!editMode">
                    Bearbeiten
                </button>
            </mat-card-header>
            <mat-card-content>
                <div class="row">
                    <div class="col-3">
                        <mat-form-field>
                            <mat-label>Listenname</mat-label>
                            <input matInput [(ngModel)]="avl.listenName" [disabled]="!editMode">
                        </mat-form-field>
                    </div>
                    <div class="col-3">
                        <mat-form-field>
                            <mat-label>Gültig von</mat-label>
                            <input matInput type="date" [(ngModel)]="avl.validFrom" [disabled]="!editMode">
                        </mat-form-field>
                    </div>
                    <div class="col-3">
                        <mat-form-field>
                            <mat-label>Gültig bis</mat-label>
                            <input matInput type="date" [(ngModel)]="avl.validTo" [disabled]="!editMode">
                        </mat-form-field>
                    </div>
                    <div class="col-3">
                        <mat-form-field>
                            <mat-label>Version</mat-label>
                            <input matInput [(ngModel)]="avl.version" [disabled]="true" [readOnly]="true">
                        </mat-form-field>
                    </div>
                </div>
            </mat-card-content>
            <mat-card-content *ngIf="editMode" style="display: flex;">
                <button mat-raised-button color="primary" style="margin-left: auto;" (click)="save()" [disabled]="saving">
                    Speichern &nbsp; <i class="fa fa-spinner fa-spin fa-fw" *ngIf="saving"></i>
                </button>
            </mat-card-content>
        </mat-card>
        <mat-card class="mt-5">
            <mat-card-header>
                <mat-card-title>Positionen</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <mat-form-field style="width: 100%;">
                    <mat-label>
                      Suche
                    </mat-label>
                    <input matInput [formControl]="search">
                  </mat-form-field>
                  <table mat-table [dataSource]="this.avl?.preiseFiltered" matSort style="width: 100%;" [hidden]="this.avl?.preiseFiltered?.length == 0">
                    <ng-container matColumnDef="action">
                      <th mat-header-cell mat-sort-header *matHeaderCellDef>
                        
                      </th>
                      <td mat-cell *matCellDef="let element">
                        <mat-icon *ngIf="!element.edit && !element.saving" style="font-size: 16px; cursor: pointer;" (click)="element.edit = true">mode_edit</mat-icon>
                        <mat-icon *ngIf="element.edit && !element.saving" style="font-size: 24px; cursor: pointer; color: green;" (click)="savePos(element)">check_circle_outline</mat-icon>
                        <mat-spinner *ngIf="element.saving" diameter="24"></mat-spinner>
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="pos">
                      <th mat-header-cell mat-sort-header *matHeaderCellDef>
                        Pos.
                      </th>
                      <td mat-cell *matCellDef="let element">
                        <span *ngIf="!element.edit">{{element.zeile}}</span>
                          <input *ngIf="element.edit" type="number" [(ngModel)]="element.zeile" style="width: 50px;">
                      </td>
                    </ng-container>

                    <ng-container matColumnDef="name">
                      <th mat-header-cell mat-sort-header *matHeaderCellDef>
                        Bezeichnung
                      </th>
                      <td mat-cell *matCellDef="let element"> {{element.name}} </td>
                    </ng-container>

                    <ng-container matColumnDef="pzn">
                      <th mat-header-cell mat-sort-header *matHeaderCellDef>
                        PZN
                      </th>
                      <td mat-cell *matCellDef="let element"> {{element.pzn}} </td>
                    </ng-container>
                    
                    <ng-container matColumnDef="gebinde">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>
                          Gebinde
                        </th>
                        <td mat-cell *matCellDef="let element"> 
                          <span *ngIf="!element.edit">{{element.gebindeanzahl}}</span>
                          <input *ngIf="element.edit" type="number" [(ngModel)]="element.gebindeanzahl" style="width: 50px;">
                        </td>
                      </ng-container>

                      <ng-container matColumnDef="gruppierung">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>
                          Gruppierung
                        </th>
                        <td mat-cell *matCellDef="let element"> 
                          <span *ngIf="!element.edit">{{element.gruppierung}}</span>
                          <input *ngIf="element.edit" type="number" [(ngModel)]="element.gruppierung" style="width: 50px;">
                        </td>
                      </ng-container>

                      <ng-container matColumnDef="unterGruppierung">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>
                          Untergruppierung
                        </th>
                        <td mat-cell *matCellDef="let element">
                          <span *ngIf="!element.edit">{{element.unterGruppierung}}</span>
                          <input *ngIf="element.edit" type="number" [(ngModel)]="element.unterGruppierung" style="width: 50px;">
                        </td>
                      </ng-container>

                    <ng-container matColumnDef="einkaufspreis">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>
                          Listenpreis
                        </th>
                        <td mat-cell *matCellDef="let element">
                          <span *ngIf="!element.edit">{{element.einkaufspreis / 10000 | currency:'EUR'}}</span>
                          <input *ngIf="element.edit" type="number" [(ngModel)]="element.einkaufspreis" style="width: 100px;">
                        </td>
                      </ng-container>

                      <ng-container matColumnDef="menge1">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>
                          Menge 1
                        </th>
                        <td mat-cell *matCellDef="let element">
                          <span *ngIf="!element.edit">{{element.preise[0].menge}}</span>
                          <input *ngIf="element.edit" type="number" [(ngModel)]="element.preise[0].menge" style="width: 50px;">
                        </td>
                      </ng-container>

                      <ng-container matColumnDef="preis1">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>
                          Preis 1
                        </th>
                        <td mat-cell *matCellDef="let element">
                          <span *ngIf="!element.edit">{{element.preise[0].preis / 10000 | currency:'EUR'}}</span>
                          <input *ngIf="element.edit" type="number" [(ngModel)]="element.preise[0].preis" style="width: 100px;">
                        </td>
                      </ng-container>

                      <ng-container matColumnDef="menge2">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>
                          Menge 2
                        </th>
                        <td mat-cell *matCellDef="let element">
                          <span *ngIf="!element.edit">{{element.preise[1].menge}}</span>
                          <input *ngIf="element.edit" type="number" [(ngModel)]="element.preise[1].menge" style="width: 50px;">
                        </td>
                      </ng-container>

                      <ng-container matColumnDef="preis2">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>
                          Preis 2
                        </th>
                        <td mat-cell *matCellDef="let element">
                          <span *ngIf="!element.edit">{{element.preise[1].preis / 10000 | currency:'EUR'}}</span>
                          <input *ngIf="element.edit" type="number" [(ngModel)]="element.preise[1].preis" style="width: 100px;">
                        </td>
                      </ng-container>

                      <ng-container matColumnDef="menge3">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>
                          Menge 3
                        </th>
                        <td mat-cell *matCellDef="let element">
                          <span *ngIf="!element.edit">{{element.preise[2].menge}}</span>
                          <input *ngIf="element.edit" type="number" [(ngModel)]="element.preise[2].menge" style="width: 50px;">
                        </td>
                      </ng-container>

                      <ng-container matColumnDef="preis3">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>
                          Preis 3
                        </th>
                        <td mat-cell *matCellDef="let element">
                          <span *ngIf="!element.edit">{{element.preise[2].preis / 10000 | currency:'EUR'}}</span>
                          <input *ngIf="element.edit" type="number" [(ngModel)]="element.preise[2].preis" style="width: 100px;">
                        </td>
                      </ng-container>

                      <ng-container matColumnDef="menge4">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>
                          Menge 4
                        </th>
                        <td mat-cell *matCellDef="let element">
                          <span *ngIf="!element.edit">{{element.preise[3].menge}}</span>
                          <input *ngIf="element.edit" type="number" [(ngModel)]="element.preise[3].menge" style="width: 50px;">
                        </td>
                      </ng-container>

                      <ng-container matColumnDef="preis4">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>
                          Preis 4
                        </th>
                        <td mat-cell *matCellDef="let element">
                          <span *ngIf="!element.edit">{{element.preise[3].preis / 10000 | currency:'EUR'}}</span>
                          <input *ngIf="element.edit" type="number" [(ngModel)]="element.preise[3].preis" style="width: 100px;">
                        </td>
                      </ng-container>

                    <tr mat-header-row *matHeaderRowDef="['action', 'pos', 'pzn', 'name', 'gebinde', 'gruppierung', 'unterGruppierung', 'einkaufspreis', 'menge1', 'preis1', 'menge2', 'preis2', 'menge3', 'preis3', 'menge4', 'preis4']"></tr>
                    <tr mat-row *matRowDef="let row; columns: ['action', 'pos', 'pzn', 'name', 'gebinde', 'gruppierung', 'unterGruppierung', 'einkaufspreis', 'menge1', 'preis1', 'menge2', 'preis2', 'menge3', 'preis3', 'menge4', 'preis4'];"></tr>
                  </table>
            </mat-card-content>
        </mat-card>
      </mat-card-content>
    </mat-card>
  </div>
  